// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"932":"3549c8d6","9623":"f795afa7"}[chunkId] + ".chunk.css";
};